import {z} from 'zod';

import {IsoUtcDateTimeSchema, UuidV4Schema} from './common.js';

/**
 * Contrato da porta interna do funil MAPA.
 *
 * ATENÇÃO, e isto precisa ficar escrito: **esta rota não está em nenhum dos
 * planos.** Os planos 02, 03 e 05 desenham porta interna para editorial,
 * publicação e métricas; o plano 04 desenha o worker do MAPA e não desenha
 * gatilho nenhum para ele. Ela existe por decisão do dono, tomada fora do
 * documento, porque sem gatilho a fila de eventos do funil não anda no processo
 * implantado: o ingresso do webhook grava o evento e ninguém o consome.
 *
 * A partição entra no corpo porque o worker é particionado por HMAC do IGSID
 * (`partitionForIgsid`), e um dia com mais de um processo consumindo a fila vai
 * precisar dizer qual fatia cada um pega. Hoje o agendador manda sempre
 * `{indice: 0, total: 1}`, que é a fila inteira num processo só.
 */

export const MapaRoundRequestSchema = z.strictObject({
  accountId: UuidV4Schema,
  /** Correlação do agendador. A janela e a reserva usam o relógio do servidor. */
  asOf: IsoUtcDateTimeSchema,
  /**
   * Fatia da fila que esta chamada consome.
   *
   * `indice` precisa ser menor que `total`: pedir a fatia 3 de 2 não é fatia
   * nenhuma, e passar isso adiante faria a rodada varrer a fila inteira sem
   * processar ninguém, calada.
   */
  partition: z
    .strictObject({
      indice: z.int().nonnegative(),
      total: z.int().positive(),
    })
    .refine((p) => p.indice < p.total, {
      message: 'indice da partição precisa ser menor que o total',
      path: ['indice'],
    })
    .optional(),
});
export type MapaRoundRequest = z.infer<typeof MapaRoundRequestSchema>;

export const MapaRoundResponseSchema = z.strictObject({
  runId: UuidV4Schema,
  status: z.enum(['queued']),
});
export type MapaRoundResponse = z.infer<typeof MapaRoundResponseSchema>;
